export default {
  install: plugins => {
    plugins.addPlugin('RelationshipUrlMutator', {
      type: 'slice',
      mutate: model => {
        return url => {
          return url.split('/').slice(...model.keep).join('/');
        };
      }
    });
    plugins.addPlugin('RelationshipUrlMutator', {
      type: 'suffix',
      mutate: model => {
        return url => `${url}${model.toAdd}`;
      }
    });
  }
};